import React from 'react';
import { Translate } from 'react-redux-i18n';

const NoData = () => {
  return (
    <div className="no-data">
      <Translate value="financialStatement.noData" />
    </div>
  );
};

export default NoData;
